import React from "react";
import { usePrefixContext } from "../../../context/PrefixContext";
import { useTranslation } from "react-i18next";

export default function MuayStepRow(props) {
    const { bData, n, bgR } = props;
    const { prefix } = usePrefixContext();
    const { t } = useTranslation();

    var play_status = {
        "1": t("WON"),
        "2": t("WON") + " (0.5)",
        "3": t("draw").toUpperCase(),
        "4": t("LOSE"),
        "5": t("LOSE") + " (0.5)",
        "6": t("Rejected"),
        "7": t("Waiting_Result")
    };

    var bill_status = {
        "1": t("WON"),
        "2": t("draw").toUpperCase(),
        "3": t("LOSE"),
        "4": t("Rejected"),
        "5": t("Waiting_Result")
    };
    
    return (
        <tr className={bgR} align="right">
            <td className="GridColor" align="left">
                {n}
            </td>
            <td className="GridColor" align="left">
                <span className="bold">{bData[0]}</span>
                <br />
                {bData[1]}
            </td>
            <td className="GridColor" align="left">
                Casino
            </td>
            <td className="GridColor" align="left">
                <span>
                    Muay Step
                    <br />
                </span><span>{bData[7][0][14]}</span>
                <br />
                Bet on <span className="Normal">{
                    bData[7].map(function (pptx, j) {
                        if(pptx[0]==1){
                            return <>{j>0 ? <br /> : null}<span>{pptx[7]+"@"+formatMoney(pptx[1], 2)}</span></>;
                        }else if(pptx[0]==2){
                            return <>{j>0 ? <br /> : null}<span>{pptx[8]+"@"+formatMoney(pptx[1], 2)}</span></>;
                        }else if(pptx[0]==21){
                            return <>{j>0 ? <br /> : null}<span>{pptx[7]+"@"+pptx[2]}</span></>;
                        }else if(pptx[0]==22){
                            return <>{j>0 ? <br /> : null}<span>{pptx[7]+"@"+pptx[2]}</span></>;
                        }else if(pptx[0]==23){
                            return <>{j>0 ? <br /> : null}<span>{pptx[8]+"@"+pptx[2]}</span></>;
                        }else if(pptx[0]==24){
                            return <>{j>0 ? <br /> : null}<span>{pptx[8]+"@"+pptx[2]}</span></>;
                        }
                    })
                }
                {
                    bData[7][0][0]==21 || bData[7][0][0]==22 || bData[7][0][0]==23 || bData[7][0][0]==24 || bData[10] == "STEP" ? <><br /> Odds:{
                        bData[7][0][0]==21 || bData[7][0][0]==22 || bData[7][0][0]==23 || bData[7][0][0]==24 ? bData[7][0][2] : formatMoney(bData[6], 2)
                    }</> : null
                }</span>&nbsp;
            </td>
            <td className="GridColor" align="center">
                <span className="Normal" style={{ display: "inline-block", width: "80px", wordBreak: "break-word" }}>RefNo:{bData[0]},{
                    bData[7].map(function (pptx, j) {
                        return <>{j>0 ? <br /> : null}{pptx[15].replace("-", ":")} {play_status[pptx[3]]}</>
                    })
            }</span>
            </td>
            <td className="GridColor" align="right">
                <span className="Simple">{formatMoney(bData[2], 2)}</span>
            </td>
            <td className="GridColor" align="center">
                <span className={bData[4]==3 ? "Error" : "Normal"}>{bill_status[bData[4]]}</span>
            </td>
            <td className="GridColor" align="right">
                <span className="Hd9 Simple">0.00</span>
            </td>
            <td className="GridColor" align="right">
                <span className={(bData[11] < 0 ? "Negative Simple" : "Hd9 Simple")}>{formatMoney(bData[11], 2)}</span>
            </td>
        </tr>
    );
}
function formatMoney(n, cx, dx, tx, jx) {
    var c = isNaN((cx = Math.abs(cx))) ? 0 : cx,
        d = dx === undefined ? "." : dx,
        t = tx === undefined ? "," : tx,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (jx = i.length) > 3 ? jx % 3 : 0;

    return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
            ? d +
            Math.abs(n - i)
                .toFixed(c)
                .slice(2)
            : "")
    );
}
function hpdConv(val) {
    var $pos1 = val.indexOf("-");
    if (val.length === 1 || $pos1 < 0) {
        return val;
    } else {
        var lv = val.split("-");
        //console.log(lv);
        var new_val = parseFloat(lv[0]) + (parseFloat(lv[1]) - parseFloat(lv[0])) / 2;
        return formatMoney(new_val, 2);
    }
}